import React, { useRef, useState, Component, useEffect } from "react";
import "./index.less";
import "@/assets/css/animate.min.css";
import { WOW } from "wowjs";
import { useLocation } from "react-router-dom";
import SkipBtn from "@/components/SkipBtn";
import AdornItem from "./component/AdornItem";
import HeadlineFlex from "@/components/HeadlineFlex";

const Index = () => {
  const location = useLocation();
  // 初始化 WOW.js
  useEffect(() => {
    // 平滑滚动到顶部
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    // 在useEffect中初始化WOW.js
    const wow = new WOW({
      boxClass: "wow",
      animateClass: "animated", // 确保这与animate.css的类名一致
      offset: 100, // 建议设置一个偏移量
      mobile: true,
      live: true,
    });
    wow.init();

    // 如果内容动态加载，可能需要这个
    return () => {
      wow.stop();
    };
  }, [location.pathname]); // 空依赖数组表示只在组件挂载时运行一次



  const HighlightsHeadline = {
    colorOne: "#fff",
    titleOne: "KEY",
    colorTwo: "#b5b5b3",
    titleTwo: "HIGHLIGHTS",
  };
  const UndertintHeadline = {
    colorOne: "#333",
    titleOne: "APPLICATIONS ",
    colorTwo: "#b5b5b3",
    titleTwo: "& USE CASES",
  };
  const services = [
    {
      img: require("@/assets/home/Our-Services1.png").default,
      order: "01",
      subhead: "High-Performance GPU Rental",
      matter:
        "Flexible, on-demand GPU resources for AI, blockchain, and big data.",
    },
    {
      img: require("@/assets/home/Our-Services2.png").default,
      order: "02",
      subhead: "AI Training & Inference",
      matter:
        "Accelerate machine learning and AI model training with powerful GPU clusters.",
    },
    {
      img: require("@/assets/home/Our-Services3.png").default,
      order: "03",
      subhead: "Blockchain Infrastructure",
      matter:
        "Secure, scalable compute power to host blockchain nodes and validate transactions.",
    },
    {
      img: require("@/assets/home/Our-Services4.png").default,
      order: "04",
      subhead: "Eco-Friendly Data Centers",
      matter:
        "Running on renewable energy, designed to maximize energy efficiency.",
    },
  ];

  const HighlightsList = [
    {
      point: require("@/assets/home/Key-Highlights1.png").default,
      title: "Sustainable Energy",
      content: "Powered by renewable energy, reducing your carbon footprint.",
    },
    {
      point: require("@/assets/home/Key-Highlights2.png").default,
      title: "High-Performance GPUs",
      content:
        "NVIDIA H100, A100 and more, designed for AI, blockchain, and large-scale data applications.",
    },
    {
      point: require("@/assets/home/Key-Highlights3.png").default,
      title: "GDPR Compliant",
      content: "Fully compliant with EU data protection standards.",
    },
    {
      point: require("@/assets/home/Key-Highlights4.png").default,
      title: "Global Connectivity",
      content: "Strong network backbone to connect major global data hubs.",
    },
  ];
  const ApplicationsList = [
    {
      title: "Artificial Intelligence",
      background: require("@/assets/home/Applications1.png").default,
      content:
        " Accelerate AI model training, machine learning, and autonomous systems.",
    },
    {
      title: "Blockchain & Web3",
      background: require("@/assets/home/Applications2.png").default,
      content:
        "Power decentralized applications, blockchain nodes, and crypto mining.",
    },
    {
      title: "Scientific Computing",
      background: require("@/assets/home/Applications3.png").default,
      content:
        "High-performance computing for drug discovery, climate research, and more.",
    },
    {
      title: "Rendering & Media",
      background: require("@/assets/home/Applications4.png").default,
      content:
        "GPU-accelerated rendering for CGI, 3D modeling, and video production.",
    },
  ];
  const ChooseUsList = [
    {
      title: "Sustainability at Core",
      content: "100% powered by renewable energy.",
    },
    {
      title: "Enterprise-Grade Security",
      content: "End-to-end encryption and compliance with GDPR.",
    },
    {
      title: "Flexible & Scalable",
      content:
        "Customizable GPU solutions for AI, blockchain, and high-performance workloads.",
    },
    {
      title: "Global Connectivity",
      content:
        "Located in Australia, with connections to major EU and global data hubs.",
    },
  ];

  return (
    <div className="index_page">
      {/* banner部分 */}
      <div className="main_banner">
        <div className="middle banner">
          <div className="txtCube ">
            <div className="content wow fadeInUp">
              <p>EMPOWERING AI, BLOCKCHAIN, </p>
              <p>AND DATA WITH SUSTAINABLE </p>
              <p>COMPUTING POWER.</p>
            </div>
            <div className="skip">
              <SkipBtn path="/contact" text="Get Started Today"></SkipBtn>
            </div>
          </div>
        </div>
      </div>

      {/*  Key Highlights */}
      <div className="HighlightsBox">
        <div className="middle">
          <div className="synopsis  wow fadeInUp">
            <HeadlineFlex {...HighlightsHeadline}></HeadlineFlex>
          </div>

          <div className="HighlightsItem">
            <div className="itemDetails">
              {HighlightsList.map((val) => {
                return (
                  <div className="cube">
                    <div className="img">
                      <img src={val.point} alt="" />
                    </div>
                    <h5>{val.title}</h5>
                    <div className="matter">{val.content}</div>
                  </div>
                );
              })}
            </div>
            <div className="itemImg">
              <img
                src={require("@/assets/home/Key-Highlights5.webp").default}
                alt=""
              />
            </div>
          </div>
        </div>
      </div>

      {/* Our Services */}
      <div className="processBox">
        <div className="middle bg_box">
          <div className="title wow fadeInRight">Our Services</div>
          <div className="content ">
            {services.map((val) => {
              return (
                <div className="content_item flex_center wow slideInUp">
                  <div className="content_left">
                    <div className="order">
                      <div className="round"></div>
                      <p>{val.order}</p>
                    </div>
                    <div className="subhead">{val.subhead}</div>
                    <div className="matter">{val.matter}</div>
                  </div>
                  <div className="content_right">
                    <img src={val.img} alt="" />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Applications & Use Cases */}
      <div className="undertintBox">
        <div className="middle">
          <div className="headline wow fadeInUp">
            <HeadlineFlex {...UndertintHeadline}></HeadlineFlex>
          </div>
          <div className="bottomContent">
            {ApplicationsList.map((val) => {
              return (
                <div className="cube">
                  <div className="img">
                    <img src={val.background} alt="" />
                  </div>
                  <h5>{val.title}</h5>
                  <div className="matter">{val.content}</div>
                  {/* <div className="see">
                    <span>see more</span>
                    <div className="dit">
                      <ArrowRightOutlined />
                    </div>
                  </div> */}
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* ChooseUs */}
      <div className="ChooseUsBox">
        <div className="middle">
          <div className="Headline">
            {/* <div className="label">./Why Choose Us</div> */}
            <div className="caption wow fadeInRight">
              <h4>Why Choose Us</h4>
              {/* <div className="matter"></div> */}
            </div>
          </div>

          <div className="ChooseItem">
            {ChooseUsList.map((val) => {
              return <AdornItem {...val} width="49%"></AdornItem>;
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
